<template>
  <div>
    <h6><i class="fas fa-mortar-pestle"></i>
    <router-link class="text-primary" event="" :to="{ name: 'recipeView', params: { id: item.id }}" v-on:click.native="viewRecipe">{{ item.title }}</router-link>
    </h6>
    <p class="meta" v-if="item.collaborators && item.collaborators.length>0">
     Collaborators:  <span class="meta-bit" v-for="(clb,idx) of item.collaborators" :key="idx"> {{ clb.name }} <span v-if="idx<item.collaborators.length-1">,</span></span>
     
    </p>
    <p class="meta-desc">{{ item.description }}</p>
    <p v-if="item.targetGroup && (item.targetGroup.constructor === Array && item.targetGroup[0].type && item.targetGroup[0].type.constructor === Array)">
     <template  v-for="targetgroup in item.targetGroup">
     <TargetLabel class="targ-label" v-for="target in targetgroup.type" :target="target" :key="target.key" v-show="target"/>
     </template>
    </p>
  </div>
</template>


<script>
import TargetLabel from './TargetLabel'

let parser = document.createElement('a')
export default {
  name: 'result',
  props: ['item'],
  components: { TargetLabel },
  methods: {
    domainOf: url => ((parser.href = url), parser.hostname.replace(/^www\./, '')),
    viewRecipe: function(){
      
      var event = new CustomEvent("openView", {
              detail: {
                type:"Recipe",
                id: this.item.id
              }
            });
         this.$emit('openView',event);
    }
  }
}
</script>

<style scoped>
  .meta {
    color: #777;
    font-size: .85em;
  }
  .meta-bit {
    color: #333;
    font-weight: bold;
  }
  
  .meta-desc{
    overflow:hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  .fas{
    color:#afacac;
    margin-right:5px;
    vertical-align: text-top;
  }

  .targ-label {
    margin-left: 0.4em;
    white-space: nowrap;
    padding: 3px 8px 3px 8px;
    border-radius: 25px;
    color: white;
    font-size: 12px;
    font-weight: bold;
    display: inline-block;
    margin-top: 1em;
  }
</style>


// WEBPACK FOOTER //
// src/plugins/SearchPlugin/components/RecipeResult.vue